import { useStationsFinder } from '@app/core/stations/hooks/useStations';
import { useCompositionQuery } from '@app/modules/compose/hooks/useCompositionQuery';
import { useParams } from 'react-router';

/**
 * Resolved composition detail (video-editor) and its station from composition.stationId.
 */
export function useComposition() {
  const { compositionId } = useParams<{ compositionId: string }>();
  const compositionQuery = useCompositionQuery(compositionId!);
  const finder = useStationsFinder();

  if (!compositionQuery.data) {
    throw new Error(`Composition with id ${compositionId} not loaded`);
  }

  const composition = compositionQuery.data;
  const station = finder(composition.stationId!)!;

  return {
    composition,
    station,
    compositionQuery,
  };
}
